
import { mapGetters } from 'vuex'
import btn from '../components/btn'
import popupInput from '../../components/popupInput'
import popupRadio from '../../components/popupRadio'
import popupRadioButton from '../../components/popupRadioButton'
import { UPLOAD_COMMON_TYPE } from '@/enum/uploadType'
import imUpload from '@/components/Upload/imUpload'
export default {
    components: {
        btn,
        popupInput,
        popupRadio,
        popupRadioButton,
        imUpload
    },
    props: {
        content: {
            type: Object,
            default: () => ({})
        },
        mentionedUser: {
            type: String,
            default: ''
        },
        canSeeBtns: {
            type: Boolean,
            default: false
        },
        displayData: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            UPLOAD_COMMON_TYPE,
            // 是否实人认证
            isFaceCertified: false,
            // 包赔资料是否有效，true:有效
            compensationEffective: false,
            // 是否需要签署合同， true:需要
            needSignContract: false,
            // 合同状态，-1：还没有生成合同，0：待签，1：已签
            contractStatus: false,
            // 财务打款状态，0：提交收款账号，1：财务打款中，2：打款失败，3：打款成功
            financeRemitStatus: 0,
            // 当前是否已经提交其他平台
            isSubmitedOtherPlatform: false,
            // 表单1
            isSuccess1: false,
            isShow1: false,
            submitLoading1: false,
            btnLoading1: false,
            // 表单2
            step: 1,
            isShow2: false,
            submitLoading2: false,
            examplePic: 'https://doss.pzds.com/information/lQLPJwcgS2zmXKnNAjLNAlywTjSw5z7aVEwIc8XYRvjJAA_604_562.png',
            rules: {
                contactName: [
                    { required: true, message: '请填写紧急联系人', trigger: 'input' }
                ],
                contactPhone: [
                    { required: true, message: '请填写紧急人联系电话', trigger: 'input' }
                ],
                paymentType: [
                    { required: true, message: '请选择收款方式', trigger: 'change' }
                ],
                realName: [
                    { required: true, message: '请填写真实姓名', trigger: 'input' }
                ],
                paymentAccount: [
                    { required: true, message: '请填写收款帐户', trigger: 'input' }
                ],
                thirdBuyPlatform: [
                    { required: true, message: '请选择合作续保平台', trigger: 'change' }
                ],
                thirdOrderImgs: [
                    { required: true, message: '请上传凭证', trigger: 'change' }
                ]
            },
            platforms: [],
            form1: {},
            form2: {}
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            imOrderInfo: 'ry/imOrderInfo'
        })
    },
    beforeDestroy () {
        this.removePageShow()
    },
    methods: {
        openPopup1 () {
            this.isSuccess1 = false
            this.form1 = {}
            this.btnLoading1 = true
            this.workOrder35GetOrderFinanceStatus(() => {
                this.isShow1 = true
                this.$nextTick(() => {
                    this.$refs.formRef1 && this.$refs.formRef1.clearValidate()
                })
            })
        },
        // 查询订单财务打款状态
        workOrder35GetOrderFinanceStatus (cb) {
            return this.$api.workOrder35GetOrderFinanceStatus({ orderId: this.content.orderId }).then(res => {
                if (!res.success) {
                    return this.$message.error(res.info)
                }

                const data = res.data
                // 是否实人认证
                this.isFaceCertified = data.isFaceCertified
                // 包赔资料是否有效，true:有效
                this.compensationEffective = data.compensationEffective
                // 是否需要签署合同， true:需要
                this.needSignContract = data.needSignContract
                // 合同状态，-1：还没有生成合同，0：待签，1：已签
                this.contractStatus = data.contractStatus
                // 财务打款状态，0：提交收款账号，1：财务打款中，2：打款失败，3：打款成功
                this.financeRemitStatus = data.financeRemitStatus

                this.form1 = {
                    paymentType: data.paymentType,
                    realName: data.realName,
                    paymentAccount: data.paymentAccount
                }
                // 财务打款中
                if (data.financeRemitStatus >= 1) {
                    this.isSuccess1 = true
                }
                cb && cb()
                return data
            }).finally(() => {
                this.btnLoading1 = false
            })
        },
        submitForm1 () {
            if (!this.isFaceCertified) {
                this.$confirm('您当前暂未进行实人认证，请前往应用中心下载盼之代售APP或在浏览器打开m7.pzds.com进行认证！', '提示', {
                    confirmButtonText: '我知道了',
                    showCancelButton: false,
                    type: 'warning'
                })
                return
            }
            this.$refs.formRef1.validate(valid => {
                if (valid) {
                    this.submitLoading1 = true
                    // 已有合同，待签署
                    if (this.contractStatus == 0) {
                        this.workOrder35GetFDDSignUrl()
                        return
                    }
                    this.$api.workOrder35SubmitAccountSignContract({ ...this.form1, orderId: this.content.orderId }).then(res => {
                        if (!res.success) {
                            return this.$message.error(res.info)
                        }

                        // 需要签署合同，还没有生成合同
                        if (this.needSignContract && this.contractStatus == '-1') {
                            this.workOrder35GetFDDSignUrl()
                            return
                        }

                        this.isSuccess1 = true
                        // 改成 打款中
                        this.financeRemitStatus = 1
                    }).finally(() => {
                        this.submitLoading1 = false
                    })
                }
            })
        },
        // 法大大获取参与方签署链接
        workOrder35GetFDDSignUrl () {
            this.$api.workOrder35GetFDDSignUrl({ orderId: this.content.orderId }).then(res => {
                if (!res.success) {
                    return this.$message.error(res.info)
                }
                // 变成合同待签署状态
                this.contractStatus = 0
                this.removePageShow()
                document.addEventListener('visibilitychange', this.watchSignStatus)
                window.open(res.data.actorSignTaskUrl)
            }).finally(() => {
                this.submitLoading1 = false
            })
        },
        removePageShow () {
            document.removeEventListener('visibilitychange', this.watchSignStatus)
        },
        // 查询签约状态
        watchSignStatus () {
            if (!this.isShow1) { return }
            if (document.visibilityState === 'visible') {
                this.$api.workOrder35GetOrderFinanceStatus({ orderId: this.content.orderId }).then(res => {
                    if (!res.success) {
                        return this.$message.error(res.info)
                    }
                    // 财务打款状态，0：提交收款账号，1：财务打款中，2：打款失败，3：打款成功
                    this.financeRemitStatus = res.data.financeRemitStatus
                    // -1：还没有生成合同，0：待签，1：已签
                    this.isSuccess1 = res.data.contractStatus == 1
                })
            }
        },
        openPopup2 () {
            // 获取续保合作平台
            this.workOrder35GetCooperationPlatform()
            this.isShow2 = true
            this.step = 1
            this.form2 = {}
        },
        // 获取续保合作平台
        workOrder35GetCooperationPlatform () {
            this.$api.workOrder35GetCooperationPlatform().then(res => {
                if (!res.success) {
                    return this.$message.error(res.info)
                }
                this.platforms = res.data.map(item => ({
                    label: item,
                    value: item
                }))
            })
        },
        submitForm2 () {
            // 介绍页，跳转下一页
            if (this.step == 1) {
                this.step = 2
                this.$nextTick(() => {
                    this.$refs.formRef2 && this.$refs.formRef2.clearValidate()
                })
            } else {
                this.$refs.formRef2.validate(valid => {
                    if (valid) {
                        this.submitLoading2 = true
                        this.$api.workOrder35SellerSupplementCompensationInfo({
                            orderId: this.content.orderId,
                            thirdBuyPlatform: this.form2.thirdBuyPlatform,
                            thirdOrderImgs: this.form2.thirdOrderImgs.join(',')
                        }).then(res => {
                            if (!res.success) {
                                return this.$message.error(res.info)
                            }
                            this.isSubmitedOtherPlatform = true
                            this.$message.success('提交成功')
                            this.isShow2 = false
                        }).finally(() => {
                            this.submitLoading2 = false
                        })
                    }
                })
            }
        }
    }
}
